const theme = {
  colors: {
    background:
      'radial-gradient(circle at top, #191919, #101010)',
    dark: 'hsl(229, 25%, 31%)',
    scissors: {
      primary: 'linear-gradient(0deg, hsl(39, 89%, 49%), hsl(40, 84%, 53%))',
      secondary: 'hsl(28, 77%, 44%)',
    },
    paper: {
      primary: 'linear-gradient(0deg, hsl(230, 89%, 62%), hsl(230, 89%, 65%))',
      secondary: 'hsl(230, 64%, 46%)',
    },
    rock: {
      primary: 'linear-gradient(0deg, hsl(349, 71%, 52%), hsl(349, 70%, 56%))',
      secondary: 'hsl(347, 75%, 35%)',
    },
    lizard: {
      primary: 'linear-gradient(0deg, hsl(261, 73%, 60%), hsl(261, 72%, 63%))',
      secondary: 'hsl(261, 51%, 44%)',
    },
    spock: {
      primary: 'linear-gradient(0deg, hsl(189, 59%, 53%), hsl(189, 58%, 57%))',
      secondary: 'hsl(194, 58%, 42%)',
    },
  },
};

export default theme;
